module.exports = __webpack_public_path__ + "media/images/ticket/close-2199e530c75282f973bcff086c227921.png";